import axios from 'axios'
import config from '../config'

const {SERVER_URL} = config()

const PublicWebClient = axios.create({
    baseURL : `${SERVER_URL}/api`
})

export default PublicWebClient